import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const FolderIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.00086 7.01439L2.00078 14.618C2.00077 15.7226 2.8962 16.618 4.00078 16.618L15.9997 16.618C17.1043 16.618 17.9997 15.7226 17.9997 14.6181L18 6.84421C18 6.29191 17.5523 5.84418 17 5.84418H10.0697L7.76555 3.38281H3.00038C2.44794 3.38281 2.00017 3.83012 2.00034 4.38256C2.00058 5.16801 2.00086 6.25279 2.00086 7.01439Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

FolderIcon.displayName = 'FolderIcon';
